<template>
  <div class="login_popup" style="background: #fff;">
    <div class="pager" v-if="showForget != '2'">
      <span class="cur_pager">{{ progress + 1 }}</span>
      <span>/2</span>
    </div>
    <div v-if="loginSuc" class="login_popup">
      <div class="login_success">
        <img src="../../src/images/login/success.svg" alt />
        <div class="suc_mess">密码修改成功</div>
        <!--<div class="to_jump">正在跳转{{sucTo}}s</div>-->
      </div>
    </div>
    <div v-if="!loginSuc" class="forget_view">
      <div class="back_prev" v-if="roleEnName != 'collegeadmin' && roleEnName != 'eduadmin'">
        <img style="width:16px; height:16px;" class="cursor_p" @click="returnPrev()"
          src="../../src/images/login/ico_return.jpg" alt />
        <span @click="returnPrev()">返回</span>
      </div>
      <div class="mess_pop">
        <div v-if="ifNotied" class="notied fadein">该手机号未绑定账号，请使用账号登录后在设置中绑定手机号</div>
      </div>
      <div class="forget_box">
        <div class="login_tit">
          <ul class="forget_tit">
            <li>
              {{ !progress ? '验证身份' : '设置新密码' }}
            </li>
          </ul>
        </div>
        <div class="forget_inp_first" v-if="!progress">
          <div class="forget_abb login_input forget_input">
            <el-input name="forgetabb" type="text" v-model.trim="forGetadd" @focus="inpFocus($event)"
              @blur="inpBlur($event)" maxlength="50" id="forgetabb" placeholder="请输入学校简称+学号" />
          </div>
          <div class="forget_phone login_input forget_input">
            <el-input name="forgetphone" type="text" v-model.trim="forgetphone" @focus="inpFocus($event)"
              @blur="inpBlur($event)" maxlength="50" id="forgetphone" placeholder="请输入手机号" />
          </div>
          <div class="forget_code login_input forget_input">
            <p class="getCode cursor_p" :style="codeStyle" :id="getCodeAfter ? 'getcodeAfter' : null" @click="getCode()"
              v-text="getCodeAfter ? '已发送(' + codeAfterNum + 's)' : '获取验证码'"></p>
            <el-input name="forgetcode" type="text" v-model.trim="forgetcode" @focus="inpFocus($event)"
              :class="{ 'error_input': errPop }" @blur="inpBlur($event)" maxlength="50" id="forgetcode"
              placeholder="请输入验证码" />
            <div v-if="showErr" class="err_mess">
              <p v-text="errPop"></p>
            </div>
          </div>
        </div>
        <div class="forget_inp_second" v-if="progress">
          <div class="forget_newpass login_input forget_input">
            <form>
              <el-input name="forgetnewpass" :type="show1 ? '' : 'password'" maxlength="50" id="forgetnewpass"
                autocomplete="new-password" @focus="inpFocus($event)" @blur="inpBlur($event)" v-model.trim="newPass"
                placeholder="请输入您的新密码"
                :class="{ 'error_input': clearPassWordForm.showRule == '1' || clearPassWordForm.showRule == '4' || showErr }"
                @input="inputIng" />
            </form>
            <div class="eye_box" v-show="show1" @click="show1 = false"><img src="../../src/images/login/show.svg" alt />
            </div>
            <div class="eye_box" v-show="!show1" @click="show1 = true"><img src="../../src/images/login/no_show.svg"
                alt /></div>
          </div>
          <div class="forget_newpass_again login_input forget_input">
            <form>
              <el-input name="forgetnewpassagain" :type="show2 ? '' : 'password'" maxlength="50" id="passagain"
                :class="{ 'error_input': clearPassWordForm.showRule == '1' || clearPassWordForm.showRule == '4' || showErr }"
                @focus="inpFocus($event)" @blur="inpBlur($event)" v-model.trim="newPassAgain" placeholder="请再次输入新密码" />
            </form>
            <div class="eye_box" v-show="show2" @click="show2 = false"><img src="../../src/images/login/show.svg" alt />
            </div>
            <div class="eye_box" v-show="!show2" @click="show2 = true"><img src="../../src/images/login/no_show.svg"
                alt /></div>
            <div v-if="showErr" class="err_mess">
              <p v-text="errPop"></p>
            </div>
          </div>
        </div>
        <!-- <div class="accouent_save hint" v-if="progress && userSave">为保障您的账号安全，密码长度8-20位且至少包含大写字母、小写字母、数字或特殊符号中的任意三种</div> -->
        <div class="rule_box" v-if="progress && userSave">
          <div class="rule_first rule">
            <img
              :src="newPass ? ((clearPassWordForm.showRule == '1' || clearPassWordForm.showRule == '4') ? require('../images/login/rele_red_icon.svg') : require('../images/login/rele_action_icon.svg')) : require('../images/login/rele_icon.svg')">
            <span class="rule_text"
              :class="{ 'action_text': newPass, 'red_text': clearPassWordForm.showRule == '1' || clearPassWordForm.showRule == '4' }">密码由8-20位数字、大小写字母或符号组成</span>
          </div>
          <div class="rule_second rule">
            <img
              :src="newPass ? ((clearPassWordForm.showRule == '2' || clearPassWordForm.showRule == '4') ? require('../images/login/rele_red_icon.svg') : require('../images/login/rele_action_icon.svg')) : require('../images/login/rele_icon.svg')">
            <span class="rule_text"
              :class="{ 'action_text': newPass, 'red_text': clearPassWordForm.showRule == '2' || clearPassWordForm.showRule == '4' }">至少包含3种以上字符</span>
          </div>
          <div class="rule_third rule">
            <img
              :src="newPass ? ((clearPassWordForm.showRuleWeak == '3') ? require('../images/login/rele_red_icon.svg') : require('../images/login/rele_action_icon.svg')) : require('../images/login/rele_icon.svg')">
            <span class="rule_text"
              :class="{ 'action_text': newPass, 'red_text': clearPassWordForm.showRuleWeak == '3' }">密码中不能出现例如“1234”“1111”等弱密码</span>
          </div>
        </div>
        <div class="login_btn forget_btn">
          <button v-if="!progress" class="cursor_p" @click="forgetNext()">下一步</button>
          <button v-else class="cursor_p" @click="forgetLogin()">完成</button>
        </div>
        <div class="forget_hint hint" v-if="!progress && userSave">若账号忘记或绑定手机号不可用，请联系老师或管理员重置密码</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { getNewValidateCode, checkNewValidateCode, resetNewPassWord, updatePwdNew, checkWeakPsWd } from "../request/api";
import CryptoJS from "crypto-js";
export default {
  props: ['showForget','userName','oldPass','roleEnName'],
  watch: {
    showForget: {
      handler(newValue) {
        if (newValue == '2') {
          this.progress = 1
        }
      },
      immediate: true,
      deep: true
    },
  },
  data() {
    return {
      throttle: false,
      show1: false,
      show2: false,
      progress: 0,
      forGetadd: "",
      forgetphone: "",
      forgetcode: "",
      newPass: "",
      newPassAgain: "",
      loginSuc: false,
      sucTo: 3,

      codeAfterNum: 60,
      getCodeAfter: false,
      ifNotied: false,

      codeSucced: true,

      showErr: false,
      errPop: "",

      userSave: true,
      codeStyle: "color: #a6a7a9;", //获取验证码样式

      // 重置密码弹窗数据
      clearPassWordForm: {
        showRule: '',
        switchValue: '0',
        radio: 1,
        historyPassWord: '',
        showRuleWeak: '1',
      },
    }
  },
  created() { },
  mounted() {
    if (this.showForget == '2') {
      this.progress = 1
    } else {
      this.progress = 0
    }
  },
  //this.forGetadd || !this.forgetphone
  watch: {
    forGetadd() {
      if (!this.forGetadd || !this.forgetphone) {
        this.codeStyle = "color: #a6a7a9;";
      } else {
        this.codeStyle = "";
      }
    },
    forgetphone() {
      if (!this.forGetadd || !this.forgetphone) {
        this.codeStyle = "color: #a6a7a9;";
      } else {
        this.codeStyle = "";
      }
    }
  },
  methods: {
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      return localhostPath;
    },
    //获取iplat路径
    getIplatPath() {
      var curWwwPath = window.document.location.href;
      var pos = curWwwPath.indexOf('/fifLogin');
      var iplatPath = curWwwPath.substring(0, pos);
      return iplatPath;
    },
    forgetNext() {
      const that = this;
      this.userSave = true;
      if (this.forGetadd == null || this.forGetadd == "") {
        // $(".forget_abb input").focus();
        // $(".forget_abb input").css({ "border-bottom": "#3388FF solid 1px" });
        return false;
      } else if (this.forgetphone == null || this.forgetphone == "") {
        // $(".forget_phone input").focus();
        // $(".forget_phone input").css({ "border-bottom": "#3388FF solid 1px" });
        return false;
      } else if (this.forgetcode == null || this.forgetcode == "") {
        // $(".forget_code input").focus();
        // $(".forget_code input").css({ "border-bottom": "#3388FF solid 1px" });
        return false;
      } else {
        // $(".forget_abb input").css({ "border-bottom": "1px solid #e5e5e5" });
        // $(".forget_phone input").css({ "border-bottom": "1px solid #e5e5e5" });
        // $(".forget_code input").css({ "border-bottom": "1px solid #e5e5e5" });
      }
      checkNewValidateCode({ mobile: this.forgetphone, validCode: this.forgetcode, loginName: this.forGetadd })
        .then(res => {
          if (res.status == "SUCCESS") {
            that.codeSucced = true;
            that.progress = 1;
            that.showErr = false;
          } else if (res.status == "ERROR") {
            that.showErr = true;
            that.errPop = res.message;
          }
        })
        .catch(err => {
        });
    },
    returnPrev() {
      if (this.showForget == '2') {
        this.$emit("offForget", false, 'weakPassword');
      } else if (this.progress == 0) {
        // 返回登录页面
        this.$emit("offForget", false);
      } else {
        this.progress = 0;
      }
    },
    /* 获取验证码 */
    getCode() {
      if (!this.forGetadd || !this.forgetphone) {
        // 信息未填全
        return;
      }
      this.showErr = false;
      const that = this;
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.forgetphone)) && this.forGetadd != '' && this.forgetphone != '') {
        this.userSave = false;
        this.showErr = true;
        this.errPop = "请输入正确的手机号";
        return false;
      } else {
        this.showErr = false;
        getNewValidateCode({ mobile: this.forgetphone, loginName: this.forGetadd, type: '2' })
          .then(res => {
            if (res.status == "SUCCESS") {
              that.codeSucced = true;
              that.showErr = true;
              that.errPop = res.message;
              if (this.codeAfterNum == 60) {
                this.getCodeAfter = true;
                var serCodeAfter = setInterval(() => {
                  this.codeAfterNum -= 1;
                  if (this.codeAfterNum == 0) {
                    clearInterval(serCodeAfter);
                    this.getCodeAfter = false;
                    this.codeAfterNum = 60;
                  }
                }, 1000);
              }
            } else {
              if (res.status == "ERROR") {
                that.userSave = false;
                that.showErr = true;
                that.errPop = res.message;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    /* 验证 登录 */
    forgetLogin() {
      const that = this;
      var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]){8,20}');
      var regex2 = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (this.newPass == null || this.newPass == "") {
        $(".forget_newpass input").focus();
        return false;
      } else if (this.newPassAgain == null || this.newPassAgain == "") {
        $(".forget_newpass_again input").focus();
        return false;
      } else if (this.newPass != this.newPassAgain) {
        $(".forget_newpass_again input").focus();
        this.userSave = false;
        this.showErr = true;
        this.errPop = '两次输入的密码不一致';
        return false;
      } else if (this.newPass.length < 8 || this.newPass.length > 20) {
        $(".forget_newpass_again input").focus();
        this.userSave = false;
        this.showErr = true;
        this.errPop = '密码长度8-20位且至少包含大写字母、小写字母、数字或特殊符号中的任意三种';
        return;
      } else if (!regex.test(this.newPass) || regex2.test(this.newPass)) {
        $(".forget_newpass_again input").focus();
        this.userSave = false;
        this.showErr = true;
        this.errPop = '密码长度8-20位且至少包含大写字母、小写字母、数字或特殊符号中的任意三种';
        return;
      } else if (this.clearPassWordForm.showRuleWeak == '3' && this.showForget != '2') {
        $(".forget_newpass_again input").focus();
        this.userSave = false;
        this.showErr = true;
        this.errPop = '您的密码过于简单，请重新录入';
        return
      } else {
        // 密码加密
        let Base64 = require("js-base64").Base64;
        const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
        const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
        const srcs = CryptoJS.enc.Utf8.parse(this.newPass);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        let encryptionPass = Base64.encode(encrypted)
        if (this.showForget == '2') { //如果是修改弱密码 修改完返回登录页
          console.log(this.clearPassWordForm.showRuleWeak);
          this.changePwd()
          return
        }
        resetNewPassWord({ loginName: this.forGetadd, mobile: this.forgetphone, validCode: this.forgetcode, newPass: encryptionPass })
          .then(res => {
            if (res.status == "SUCCESS") {
              // 成功跳转
              that.loginSuc = true;
              var loginSucTo = setInterval(() => {
                that.sucTo -= 1;
                if (that.sucTo == 0) {
                  clearInterval(loginSucTo);
                  window.location.href = that.getIplatPath() + '/html/index.html';
                }
              }, 1000);
            } else if (res.status == "ERROR") {
              this.userSave = false;
              that.showErr = true;
              that.errPop = res.message;
            }
          })
          .catch(err => {
            console.log(err)
          });
      }
    },

    // 修改弱密码
    changePwd() {
      if (this.clearPassWordForm.showRule == '1') return this.$message.error('密码由8-20位数字、大小写字母或符号组成');
      if (this.clearPassWordForm.showRule == '2') return this.$message.error('至少包含3种以上字符');
      if (this.clearPassWordForm.showRuleWeak == '3') return this.$message.error('您的密码过于简单，请重新录入');
      var Base64 = require("js-base64").Base64;
      const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
      const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
      const srcs1 = CryptoJS.enc.Utf8.parse(this.oldPass); // 旧密码
      let encrypted1 = CryptoJS.AES.encrypt(srcs1, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const srcs2 = CryptoJS.enc.Utf8.parse(this.newPass); // 新密码
      let encrypted2 = CryptoJS.AES.encrypt(srcs2, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      let params = {
        loginName: this.userName,
        pwd: Base64.encode(encrypted1),
        newPwd: Base64.encode(encrypted2),
      };
      updatePwdNew({ ...params }).then((res) => {
        if (res.status != "SUCCESS") {
          this.$message.error(res.message);
          this.$emit("offForget", false);//返回登录页面
          return
        } else {
          this.$message({ message: res.message, type: "success" });
          this.$emit("offForget", false);//返回登录页面
        }
      });
    },
    /* input focus blur 事件 */
    inpFocus($event) {
      // $event.path[0].style = "border-bottom: #3388FF solid 1px";
    },
    inpBlur($event) {
      // $event.path[0].style = "border-bottom: #e5e5e5 solid 1px";
    },
    inputIng() { //输入密码中
      if (this.throttle) return
      let res = this.CheckPassWord(this.newPass);
      this.clearPassWordForm.showRule = res;
      this.checkWeakPsWd()
      console.log(this.clearPassWordForm.showRule);
    },
    // 验证密码格式
    CheckPassWord(password) { //密码必须包含数字和字母 返回1不满足条件1 返回2不满足条件2 返回3不满足条件3 返回4不满足长度 返回5满足所有条件
      var str = password;
      var num = 0
      var reg1 = new RegExp(/\d/); //是否包含数字
      var reg2 = new RegExp(/[a-z]/);
      var reg3 = new RegExp(/[A-Z]/);
      var reg4 = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
      if (str.length == 0) return '0'
      reg1.test(str) ? num++ : ''
      reg2.test(str) ? num++ : ''
      reg3.test(str) ? num++ : ''
      reg4.test(str) ? num++ : ''
      if ((str.length < 8 || str.length > 20) && num < 3) return '4'
      if (str.length < 8 || str.length > 20) return '1'
      if (num < 3) return '2'
      return '5'
    },
    // 调用弱密码库
    async checkWeakPsWd() {
      this.throttle = false;
      var Base64 = require("js-base64").Base64;
      const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
      const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
      const srcs = CryptoJS.enc.Utf8.parse(this.newPass); // 新密码
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      let params = {
        password: Base64.encode(this.newPass),
      };
      const result = await checkWeakPsWd({ ...params });
      if (result.status == '1' || result.status == 'SUCCESS') {
        if (result.data == '密码正常') {
          console.log('密码正常');
          this.clearPassWordForm.showRuleWeak = '1'
          return
        } else {
          if (!this.newPass.length) {
            return
          } else {
            this.clearPassWordForm.showRuleWeak = '3'
          }
        }
      } else {
        this.clearPassWordForm.showRuleWeak = '3'
      }
    },
  }
};
</script>

<style scoped lang="scss">
.forget_code {
  position: relative;
}

.err_mess p {
  position: relative;
  font-size: 12px;
  color: #ff553a;
  letter-spacing: 0;
}

.forget_newpass_again {
  position: relative;
}

.eye_box {
  position: absolute;
  right: 16px;
  top: 30%;
}

// _______________________________________________________________
.login_popup {
  .pager {
    position: absolute;
    top: 26px;
    right: 32px;
    width: 64px;
    height: 32px;
    background: #f0faff;
    border-radius: 16px;
    color: #409FFF;
    text-align: center;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .cur_pager {
      font-size: 20px;
    }
  }

  .forget_box {
    padding: 40px 32px 0;

    .login_tit {
      height: auto;

      .forget_tit {
        li {
          border: none;
          font-size: 24px !important;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500 !important;
          text-align: center !important;
          color: #12151a !important;
          line-height: 28px !important;
        }
      }
    }
  }
}

.forget_view {
  border-radius: 12px;

  .back_prev {
    border-radius: 12px;
    display: flex;
    padding: 32px;
    padding-bottom: 0px;
    display: flex;
    align-items: center;

    span {
      cursor: pointer;
      font-size: 14px;
    }
  }
}

.rule_box {
  margin-top: 12px;

  .rule {
    margin-bottom: 6px;

    .rule_text {
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #c2c7cc;
      line-height: 16px;
    }

    img {
      margin-bottom: -3px;
    }

    .action_text {
      color: #23DA7D;
    }

    .red_text {
      color: #FF553A;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forgetView.vue